import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedSelect = _resolveComponent("SharedSelect")!
  const _component_UIInput = _resolveComponent("UIInput")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedWindow = _resolveComponent("SharedWindow")!

  return (_openBlock(), _createBlock(_component_SharedWindow, {
    class: _normalizeClass(_ctx.b()),
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('wrapper'))
      }, [
        _createElementVNode("h2", {
          class: _normalizeClass(_ctx.b('title'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("Изменение статуса")) + " ", 1),
          _hoisted_1,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("пользователя")) + " " + _toDisplayString(_ctx.displayedEmail), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('form'))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('field'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('field-label'))
            }, _toDisplayString(_ctx.$t("Статус")), 3),
            _createVNode(_component_SharedSelect, {
              view: "light",
              options: _ctx.displayedOptions,
              value: _ctx.adminUserAppStatus.status,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.adminUserAppStatus.status) = $event))
            }, null, 8, ["options", "value"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('field'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('field-label'))
            }, _toDisplayString(_ctx.$t("Комментарий для пользователя (на русском)")), 3),
            _createVNode(_component_UIInput, {
              placeholder: "Добавьте комментарий при необходимости",
              view: "light",
              "placeholder-view": "light",
              modelValue: _ctx.adminUserAppStatus.messageRu,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.adminUserAppStatus.messageRu) = $event))
            }, null, 8, ["modelValue"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('field'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('field-label'))
            }, _toDisplayString(_ctx.$t("Комментарий для пользователя (на английском)")), 3),
            _createVNode(_component_UIInput, {
              placeholder: "Добавьте комментарий при необходимости",
              view: "light",
              "placeholder-view": "light",
              modelValue: _ctx.adminUserAppStatus.messageEn,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.adminUserAppStatus.messageEn) = $event))
            }, null, 8, ["modelValue"])
          ], 2)
        ], 2),
        _createVNode(_component_UIButton, {
          class: _normalizeClass(_ctx.b('update')),
          label: _ctx.displayedUpdateLabel,
          view: "main",
          disabled: _ctx.isUpdateDisabled,
          onClick: _ctx.handleChangeStatus
        }, null, 8, ["class", "label", "disabled", "onClick"])
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "onClose"]))
}